import React, { useEffect, useState, useCallback } from "react";
import {
  Badge,
  Card,
  Tabs,
  Form,
  Input,
  Select,
  Rate,
  Button,
  Row,
  Col,
  Space,
  Checkbox,
  Upload,
  Typography,
  Modal,
  InputNumber,
  Divider,
  Empty,
  Spin,
  Grid,
  Tag,
  TimePicker,
  Tooltip,
} from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import moment from "moment";

import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,

  EnvironmentOutlined,
  HomeOutlined,
  FileTextOutlined,
  PictureOutlined,
  SettingOutlined,
  ArrowLeftOutlined,
  QrcodeOutlined,
  LockOutlined,
  MailOutlined
} from "@ant-design/icons";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useJsApiLoader, Autocomplete } from "@react-google-maps/api";
import apiPath from "../../constants/apiPath";
import useRequest from "../../hooks/useRequest";
import { Severty, ShowToast } from "../../helper/toast";
import LocationPicker from "../../components/hotel/LocationPicker";
import { uploadToS3 } from "../../helper/s3";
import "../../assets/styles/hotel.css";
const WebsiteURL = apiPath.WEBSITE_URL;

const { Title, Text, Paragraph } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;
const { useBreakpoint } = Grid;

const theme = {
  primary: "var(--theme1, #eca413)",
  primaryDark: "var(--theme1Dark, #132272)",
  muted: "rgba(0, 0, 0, 0.45)",
  border: "rgba(19, 34, 114, 0.12)",
};

const defaultHotel = {
  _id: null,
  Hotel_name: "",
  hotelType: "Hotel",
  starRating: 3,
  aboutHotel: "",
  country: "",
  state: "",
  city: "",
  address: "",
  landmark: "",
  latitude: null,
  longitude: null,
  rooms: [],
  facilities: [],
  media: [],
  check_in_time: "",
  check_out_time: "",
  cancellation_policy: "",
  pet_allowed: false,
  child_policy: "",
};

const AMENITY_OPTIONS = [
  "WiFi",
  "Parking",
  "Pool",
  "Gym",
  "AC",
  "Restaurant",
  "Room Service",
  "Spa",
  "Bar",
  "Conference Room"
];

const HOTEL_TYPES = ["Hotel", "Resort", "Hostel", "Villa", "Apartment"];
const ROOM_TYPES = ["Single", "Double", "Twin", "Accessible"];
const COUNTRY_CODE_OPTIONS = ["+91", "+1", "+44", "+61", "+971", "+65"];

const parsePhoneNumber = (phoneValue = "") => {
  const phone = String(phoneValue).trim();
  const withCodeMatch = phone.match(/^(\+\d{1,4})\s*(\d+)$/);

  if (withCodeMatch) {
    return { countryCode: withCodeMatch[1], contactNo: withCodeMatch[2] };
  }

  return {
    countryCode: "+91",
    contactNo: phone.replace(/\D/g, ""),
  };
};

const normalizePhoneNumber = (contactNo = "") => {
  return String(contactNo).replace(/\D/g, "");
};

const steps = [
  { key: 0, title: "Basic Info", icon: <HomeOutlined /> },
  { key: 1, title: "Location", icon: <EnvironmentOutlined /> },
  { key: 2, title: "Rooms", icon: <SettingOutlined /> },
  // { key: 3, title: "Facilities", icon: <SettingOutlined /> },
  { key: 3, title: "Media", icon: <PictureOutlined /> },
  { key: 4, title: "Policies", icon: <FileTextOutlined /> },
];

const HotelModule = () => {
  const { request } = useRequest();
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditMode = !!id;
  const authRole = localStorage.getItem("authRole") || "admin";
  let airlineId = "";
  try {
    const profile = JSON.parse(localStorage.getItem("userProfile") || "{}");
    airlineId = profile?._id || profile?.id || "";
  } catch (e) { }

  const { isLoaded: isMapsLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDQ2DCe8qS4qVCkMtRZRnZZ_TF2qq1HSvs",
    libraries: ["places"],
  });

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tabParam = queryParams.get("tab");
  const initialStep = authRole === "airline" ? 2 : (tabParam === "rooms" ? 2 : 0);

  const [currentStep, setCurrentStep] = useState(initialStep);
  const [highlightPasswordBtn, setHighlightPasswordBtn] = useState(false);

  const [airlineOptions, setAirlineOptions] = useState([]);

  useEffect(() => {
    if (tabParam === "rooms" && authRole === "airline" && currentStep === 2) {
      setHighlightPasswordBtn(true);
    } else {
      setHighlightPasswordBtn(false);
    }
  }, [tabParam, authRole, currentStep]);

  const [hotel, setHotel] = useState(defaultHotel);
  const [initialLoading, setInitialLoading] = useState(false);

  const [basicForm] = Form.useForm();
  const [locationForm] = Form.useForm();
  const [policiesForm] = Form.useForm();
  const [addressValue, setAddressValue] = useState("");
  const [addressAutocomplete, setAddressAutocomplete] = useState(null);
  const [hotelImages, setHotelImages] = useState([]);
  const [imageUploading, setImageUploading] = useState(false);
  const [roomInventory, setRoomInventory] = useState([]);
  const [roomEditModalVisible, setRoomEditModalVisible] = useState(false);
  const [editingRoom, setEditingRoom] = useState(null);
  const [roomForm] = Form.useForm();
  const [isAddingRoom, setIsAddingRoom] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [selectedAirlineId, setSelectedAirlineId] = useState(null);

  // QR Allocation State
  const [qrModalVisible, setQrModalVisible] = useState(false);
  const [selectedAllocation, setSelectedAllocation] = useState(null);
  const [passwordModalVisible, setPasswordModalVisible] = useState(false);
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [passwordForm] = Form.useForm();


  // Handle window resize for responsive design
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const fetchRoomInventory = useCallback(async (selectedId) => {
    if (!id) return;
    const targetId = selectedId || selectedAirlineId;
    if (!targetId) return;

    const params = new URLSearchParams();
    params.append("airline_id", targetId);

    request({
      url: `${apiPath.baseURL}${apiPath.getRoomInventory}/${id}?${params.toString()}`,
      method: "GET",
      onSuccess: (data) => {
        setRoomInventory(data?.rooms || []);
      },
      onError: () => setRoomInventory([]),
    });
  }, [id, request, selectedAirlineId]);

  const fetchHotelData = useCallback(async () => {
    setInitialLoading(true);
    request({
      url: `${apiPath.baseURL}${apiPath.getHotelById}/${id}`,
      method: "GET",
      onSuccess: (data) => {
        const hotelDetails = data.Hotel_details || data;
        const initialAirlineIds = hotelDetails.airline_ids && hotelDetails.airline_ids.length > 0
          ? hotelDetails.airline_ids
          : (hotelDetails.airline_id ? [hotelDetails.airline_id] : (authRole === "airline" ? [airlineId] : []));
        const defaultAirlineId = authRole === "airline" ? airlineId : (initialAirlineIds[0] || null);
        setSelectedAirlineId(defaultAirlineId);

        setHotel(prev => ({
          ...prev,
          ...hotelDetails,
          facilities: hotelDetails.facilities || [],
          media: hotelDetails.HotelImages?.map((img, index) => ({
            url: img,
            name: `Hotel Image ${index + 1}`
          })) || []
        }));

        basicForm.setFieldsValue({
          name: hotelDetails.Hotel_name,
          hotelType: hotelDetails.hotelType,
          starRating: hotelDetails.starRating || 3,
          description: hotelDetails.aboutHotel,
          // commissionRate: hotelDetails.commision_rate,
          hotelEmail: hotelDetails.hotel_email,
          airline_ids: initialAirlineIds,
          ...parsePhoneNumber(hotelDetails.hotel_phone || hotelDetails.contact_no),
          countryCode: hotelDetails.hotel_country_code || "+91",
          fullContact: `${hotelDetails.hotel_country_code || "+91"}${hotelDetails.hotel_phone || hotelDetails.contact_no || ""}`.replace(/\+/g, ''),
        });


        locationForm.setFieldsValue({
          country: hotelDetails.country,
          state: hotelDetails.state,
          city: hotelDetails.city,
          address: hotelDetails.address,
          landmark: hotelDetails.landmark,
          latitude: hotelDetails.latitude,
          longitude: hotelDetails.longitude,
        });

        if (hotelDetails.address) setAddressValue(hotelDetails.address);

        policiesForm.setFieldsValue({
          checkInTime: hotelDetails.check_in_time ? moment(hotelDetails.check_in_time, "HH:mm") : null,
          checkOutTime: hotelDetails.check_out_time ? moment(hotelDetails.check_out_time, "HH:mm") : null,
          cancellationPolicy: hotelDetails.cancellation_policy,
          petAllowed: hotelDetails.pet_allowed,
          childPolicy: hotelDetails.child_policy,
        });

        if (hotelDetails.HotelImages?.length > 0) {
          setHotelImages(hotelDetails.HotelImages.map((img, index) => ({
            uid: index,
            name: `Hotel Image ${index + 1}`,
            status: "done",
            url: img,
          })));
        }

        fetchRoomInventory(defaultAirlineId);
        setInitialLoading(false);
      },
      onError: () => {
        ShowToast("Failed to load hotel", Severty.ERROR);
        setInitialLoading(false);
      },
    });
  }, [id, request, basicForm, locationForm, policiesForm, authRole, airlineId, fetchRoomInventory]);

  const handleViewQR = () => {
    const matchingRooms = roomInventory.filter(r =>
      !selectedAirlineId ||
      String(r.airline_id) === String(selectedAirlineId) ||
      (!r.airline_id && String(hotel.airline_id) === String(selectedAirlineId))
    );
    const token = matchingRooms[0]?.qr_token || hotel.qr_token || roomInventory.find(r => r.qr_token)?.qr_token;
    const password = matchingRooms[0]?.qr_password || hotel.qr_password || roomInventory.find(r => r.qr_password)?.qr_password;
    const roomsCount = matchingRooms.reduce((acc, r) => acc + (r.available_rooms || 0), 0);

    setSelectedAllocation({
      type: "All Allocated Types",
      qr_token: token,
      qr_password: password,
      available_rooms: roomsCount,
      status: (hotel.status === 1 || hotel.status === "active" || hotel.status === true) ? 1 : 0
    });
    setQrModalVisible(true);
  };

  const handleResendEmail = async () => {
    try {
      request({
        url: `${apiPath.baseURL}${apiPath.qrResendEmail}`,
        method: "POST",
        data: {
          hotel_id: id,
          airline_id: selectedAirlineId || airlineId
        },
        onSuccess: () => ShowToast("Allocation email resent successfully", Severty.SUCCESS),
        onError: (err) => ShowToast(err?.message || "Failed to resend email", Severty.ERROR)
      });
    } catch (error) {
      ShowToast("Failed to resend email", Severty.ERROR);
    }
  };

  const handleSetPassword = async (values) => {
    try {
      setPasswordLoading(true);
      request({
        url: `${apiPath.baseURL}${apiPath.qrSetPassword}`,
        method: "POST",
        data: {
          hotel_id: id,
          password: values.password,
          airline_id: selectedAirlineId || airlineId
        },
        onSuccess: () => {
          ShowToast("Password updated successfully", Severty.SUCCESS);
          setPasswordModalVisible(false);
          passwordForm.resetFields();
          fetchRoomInventory();
        },
        onError: (err) => ShowToast(err?.message || "Failed to update password", Severty.ERROR),
        finally: () => setPasswordLoading(false)
      });
    } catch (error) {
      ShowToast("Failed to update password", Severty.ERROR);
      setPasswordLoading(false);
    }
  };
  useEffect(() => {
    if (isEditMode && id) {
      fetchHotelData();
    } else {
      basicForm.setFieldsValue({
        airline_ids: authRole === "airline" ? [airlineId] : undefined,
      });
    }

    request({
      url: "/airline/users",
      method: "GET",
      onSuccess: (res) => {
        if (res?.success && Array.isArray(res.users)) {
          const activeUsers = res.users.filter((u) => u.status === 1);
          setAirlineOptions(activeUsers.map((u) => ({ value: u._id || u.id, label: u.name })));
        }
      },
    });
  }, [id, isEditMode, authRole, airlineId, basicForm, request]);

  const addRoomToInventory = () => {
    roomForm.resetFields();
    roomForm.setFieldsValue({ type: "Single", Total_rooms: 1 });
    setIsAddingRoom(true);
    setEditingRoom(null);
    setRoomEditModalVisible(true);
  };

  const editRoomItem = (room) => {
    setEditingRoom(room);
    setIsAddingRoom(false);
    roomForm.setFieldsValue({
      type: room.type,
      Total_rooms: room.Total_rooms,
      status: room.status === undefined ? 1 : room.status,
    });
    setRoomEditModalVisible(true);
  };

  const handleRoomSubmit = async (values) => {
    if (!id) {
      ShowToast("Please save hotel basic info first", Severty.ERROR);
      return;
    }

    if (isAddingRoom) {
      request({
        url: `${apiPath.baseURL}${apiPath.addRooms}/${id}`,
        method: "POST",
        data: {
          type: values.type,
          Total_rooms: values.Total_rooms,
          airline_id: selectedAirlineId || airlineId,
        },
        onSuccess: () => {
          ShowToast("Room type added successfully", Severty.SUCCESS);
          setRoomEditModalVisible(false);
          fetchRoomInventory();
        },
        onError: (err) => {
          ShowToast(err?.response?.data?.message || "Failed to add room type", Severty.ERROR);
        },
      });
    } else {
      request({
        url: `${apiPath.baseURL}${apiPath.updateRoom}/${id}/${editingRoom.type}`,
        method: "PUT",
        data: {
          Total_rooms: values.Total_rooms,
          status: values.status,
          airline_id: selectedAirlineId || airlineId,
        },
        onSuccess: () => {
          ShowToast("Room type updated successfully", Severty.SUCCESS);
          setRoomEditModalVisible(false);
          fetchRoomInventory();
        },
        onError: (err) => {
          ShowToast(err?.response?.data?.message || "Failed to update room type", Severty.ERROR);
        },
      });
    }
  };

  const deleteRoomItem = async (roomType) => {
    Modal.confirm({
      title: "Delete Room Type",
      content: `Are you sure you want to delete ${roomType} room type? This action cannot be undone.`,
      okText: "Yes, Delete",
      cancelText: "Cancel",
      onOk: () => {
        const targetId = selectedAirlineId || airlineId;
        const queryParams = targetId ? `?airline_id=${targetId}` : "";
        request({
          url: `${apiPath.baseURL}${apiPath.deleteRoom}/${id}/${roomType}${queryParams}`,
          method: "DELETE",
          onSuccess: () => {
            ShowToast("Room type deleted successfully", Severty.SUCCESS);
            fetchRoomInventory();
          },
          onError: (err) => {
            ShowToast(err?.response?.data?.message || "Failed to delete room type", Severty.ERROR);
          },
        });
      }
    });
  };



  const handleFacilitiesChange = (checkedValues) => {
    setHotel((prev) => ({ ...prev, facilities: checkedValues }));
  };

  const saveBasicInfo = async () => {
    try {
      const values = await basicForm.validateFields();
      const airline_ids = Array.isArray(values.airline_ids) ? values.airline_ids : (values.airline_ids ? [values.airline_ids] : []);
      const primary_airline_id = airline_ids[0] || null;

      const payload = {
        Hotel_name: values.name,
        hotelType: values.hotelType,
        starRating: values.starRating,
        aboutHotel: values.description,
        commision_rate: Number(values.commissionRate) || 0,
        hotel_email: values.hotelEmail,
        airline_id: primary_airline_id,
        airline_ids: airline_ids,
        hotel_country_code: values.countryCode || "+91",
        hotel_phone: normalizePhoneNumber(values.contactNo),
      };
      if (!isEditMode) {
        payload.hotel_password = values.password;
      }

      if (!isEditMode) {
        // Create new hotel
        return new Promise((resolve) => {
          request({
            url: `${apiPath.baseURL}${apiPath.createHotel}`,
            method: "POST",
            data: payload,
            onSuccess: (data) => {
              ShowToast("Hotel created successfully", Severty.SUCCESS);
              if (data.hotel && data.hotel._id) {
                navigate(`/hotel-management/edit/${data.hotel._id}`, { replace: true });
                window.location.reload();
              }
              resolve(true);
            },
            onError: (error) => {
              ShowToast("Failed to create hotel", Severty.ERROR);
              resolve(false);
            },
          });
        });
      } else {
        // Update existing hotel
        return new Promise((resolve) => {
          request({
            url: `${apiPath.baseURL}/updateHotel/${id}`,
            method: "PUT",
            data: payload,
            onSuccess: () => {
              ShowToast("Basic info updated successfully", Severty.SUCCESS);
              resolve(true);
            },
            onError: () => {
              ShowToast("Failed to update basic info", Severty.ERROR);
              resolve(false);
            },
          });
        });
      }
    } catch (error) {
      ShowToast("Please fill all required fields", Severty.ERROR);
      return false;
    }
  };

  const saveLocation = async () => {
    try {
      const values = await locationForm.validateFields();
      const payload = {
        country: values.country,
        state: values.state,
        city: values.city,
        address: values.address,
        landmark: values.landmark,
        latitude: values.latitude,
        longitude: values.longitude
      };

      return new Promise((resolve) => {
        request({
          url: `${apiPath.baseURL}/updateHotel/${id}`,
          method: "PUT",
          data: payload,
          onSuccess: () => {
            ShowToast("Location updated successfully", Severty.SUCCESS);
            resolve(true);
          },
          onError: () => {
            ShowToast("Failed to update location", Severty.ERROR);
            resolve(false);
          },
        });
      });
    } catch (error) {
      ShowToast("Please fill all required fields", Severty.ERROR);
      return false;
    }
  };

  const saveFacilities = async () => {
    if (!hotel.facilities || hotel.facilities.length === 0) {
      ShowToast("Please select at least one facility", Severty.ERROR);
      return false;
    }

    return new Promise((resolve) => {
      request({
        url: `${apiPath.baseURL}/updateHotel/${id}`,
        method: "PUT",
        data: { amenities: hotel.facilities },
        onSuccess: () => {
          ShowToast("Facilities updated successfully", Severty.SUCCESS);
          resolve(true);
        },
        onError: () => {
          ShowToast("Failed to update facilities", Severty.ERROR);
          resolve(false);
        },
      });
    });
  };

  const saveMedia = async () => {
    if (hotelImages.length === 0) {
      ShowToast("Please upload at least one image", Severty.ERROR);
      return false;
    }

    if (!id || !isEditMode) {
      ShowToast("Complete earlier steps and save the hotel before adding media", Severty.WARNING);
      return false;
    }

    const HotelImages = hotelImages
      .map((f) => f.url)
      .filter((u) => typeof u === "string" && u.length > 0);

    if (HotelImages.length === 0) {
      ShowToast("Please upload at least one image", Severty.ERROR);
      return false;
    }

    return new Promise((resolve) => {
      request({
        url: `${apiPath.baseURL}/updateHotel/${id}`,
        method: "PUT",
        data: { HotelImages },
        onSuccess: () => {
          ShowToast("Media saved successfully", Severty.SUCCESS);
          resolve(true);
        },
        onError: () => {
          ShowToast("Failed to save media", Severty.ERROR);
          resolve(false);
        },
      });
    });
  };

  const savePolicies = async () => {
    try {
      const values = await policiesForm.validateFields();
      const payload = {
        check_in_time: values.checkInTime ? values.checkInTime.format("HH:mm") : "",
        check_out_time: values.checkOutTime ? values.checkOutTime.format("HH:mm") : "",
        cancellation_policy: values.cancellationPolicy,
        pet_allowed: values.petAllowed,
        child_policy: values.childPolicy
      };

      return new Promise((resolve) => {
        request({
          url: `${apiPath.baseURL}/updateHotel/${id}`,
          method: "PUT",
          data: payload,
          onSuccess: () => {
            ShowToast("Policies updated successfully", Severty.SUCCESS);
            resolve(true);
          },
          onError: () => {
            ShowToast("Failed to update policies", Severty.ERROR);
            resolve(false);
          },
        });
      });
    } catch (error) {
      ShowToast("Please fill all required fields", Severty.ERROR);
      return false;
    }
  };

  const validateStep = async (step) => {
    try {
      if (step === 0) {
        await basicForm.validateFields();
        return true;
      } else if (step === 1) {
        await locationForm.validateFields();
        return true;
      } else if (step === 2) {
        if (authRole !== "airline" && roomInventory.length === 0) {
          ShowToast("Please add at least one room type", Severty.ERROR);
          return false;
        }
        return true;
      }
      //  else if (step === 3) {
      //   if (!hotel.facilities || hotel.facilities.length === 0) {
      //     ShowToast("Please select at least one facility", Severty.ERROR);
      //     return false;
      //   }
      //   return true;
      // }
      else if (step === 3) {
        if (hotelImages.length === 0) {
          ShowToast("Please upload at least one hotel image", Severty.ERROR);
          return false;
        }
        return true;
      } else if (step === 4) {
        await policiesForm.validateFields();
        return true;
      }
      return true;
    } catch (error) {
      ShowToast("Please fill all required fields", Severty.ERROR);
      return false;
    }
  };

  const handleNext = async () => {
    const isValid = await validateStep(currentStep);
    if (!isValid) return;

    setIsSubmitting(true);
    let saveSuccess = true;

    if (currentStep === 0) {
      saveSuccess = await saveBasicInfo();
    } else if (currentStep === 1) {
      saveSuccess = await saveLocation();
    } else if (currentStep === 2) {
      if (authRole !== "airline" && roomInventory.length === 0) {
        ShowToast("Please add at least one room type", Severty.WARNING);
        saveSuccess = false;
      }
    }
    //  else if (currentStep === 3) {
    //   saveSuccess = await saveFacilities();
    // }
    else if (currentStep === 3) {
      saveSuccess = await saveMedia();
    } else if (currentStep === 4) {
      saveSuccess = await savePolicies();
    }

    setIsSubmitting(false);

    if (!saveSuccess) return;

    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      ShowToast("Hotel saved successfully!", Severty.SUCCESS);
      navigate("/hotel-management");
    }
  };

  const handleBack = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 0));
  };

  const getAssociatedAirlineOptions = () => {
    const associatedIds = hotel.airline_ids && hotel.airline_ids.length > 0
      ? hotel.airline_ids
      : (hotel.airline_id ? [hotel.airline_id] : []);

    return associatedIds.map(id => {
      const option = airlineOptions.find(o => o.value === id);
      return {
        value: id,
        label: option ? option.label : id
      };
    });
  };

  useEffect(() => {
    if (selectedAirlineId) {
      fetchRoomInventory(selectedAirlineId);
    }
  }, [selectedAirlineId, fetchRoomInventory]);



  if (initialLoading) {
    return (
      <div
        className="hotel-module-page"
        style={{
          minHeight: "100%",
        }}
      >
        <div >
          <Card
            bordered={false}
            style={{
              borderRadius: 16,
              boxShadow:
                "0 1px 2px rgba(19, 34, 114, 0.04), 0 12px 40px rgba(19, 34, 114, 0.08)",
              overflow: "hidden",
              position: "relative",
            }}
            bodyStyle={{ padding: 48 }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: 4,
                background: `linear-gradient(90deg, ${theme.primary} 0%, ${theme.primaryDark} 100%)`,
              }}
            />
            <div style={{ textAlign: "center", padding: "24px 0" }}>
              <Spin size="large" />
              <Paragraph type="secondary" style={{ marginTop: 20, marginBottom: 0 }}>
                Loading hotel details…
              </Paragraph>
            </div>
          </Card>
        </div>
      </div>
    );
  }

  const hotelIdLabel = hotel?.Hotel_Id || id || "";

  return (
    <div
      className="hotel-module-page"
    >
      <div >
        {/* Page header */}
        <div
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: isMobile ? "stretch" : "flex-start",
            justifyContent: "space-between",
            gap: 16,
            marginBottom: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              gap: 16,
              alignItems: "flex-start",
              flexDirection: "column",
            }}
          >
            <Button
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate("/hotel-management")}
              size="large"
              style={{
                color: theme.primary,
                fontWeight: 600,
                padding: "4px 10px",
                height: "auto",
                alignSelf: "flex-start",
              }}
            >
              Back
            </Button>
            <Space align="center" size={12} wrap >
              <div
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: 12,
                  background: `linear-gradient(135deg, ${theme.primary} 0%, ${theme.primaryDark} 100%)`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                  boxShadow: "0 8px 20px rgba(53, 80, 220, 0.35)",
                }}
              >
                {authRole === "airline" ? (
                  <SettingOutlined style={{ fontSize: 24, color: "#fff" }} />
                ) : isEditMode ? (
                  <EditOutlined style={{ fontSize: 24, color: "#fff" }} />
                ) : (
                  <HomeOutlined style={{ fontSize: 24, color: "#fff" }} />
                )}
              </div>
              <div>
                <Title
                  level={isMobile ? 4 : 3}
                  style={{
                    margin: 0,
                    fontSize: isMobile ? 20 : 26,
                    fontWeight: 800,
                    letterSpacing: "-0.02em",
                    color: "rgba(0, 0, 0, 0.88)",
                  }}
                >
                  {authRole === "airline" ? "Room availability" : isEditMode ? "Edit hotel" : "Add new hotel"}
                </Title>
                <Paragraph
                  type="secondary"
                  style={{
                    margin: "6px 0 0",
                    fontSize: 14,
                    maxWidth: 560,
                    marginBottom: 0,
                  }}
                >
                  {isEditMode
                    ? (
                      <>
                        {hotel?.Hotel_name ? (
                          <span>{hotel.Hotel_name}</span>
                        ) : (
                          <span>Update this property</span>
                        )}
                        {hotelIdLabel ? (
                          <>
                            {" · "}
                            <Text code>{hotelIdLabel}</Text>
                          </>
                        ) : null}
                      </>
                    )
                    : "Complete each step to publish your hotel — basic info, location, rooms, facilities, photos, and policies."}
                </Paragraph>
              </div>
            </Space>
          </div>
          {authRole !== "airline" && (
            <Tag
              style={{
                margin: 0,
                padding: "6px 14px",
                fontSize: 13,
                fontWeight: 600,
                borderRadius: 10,
                border: `1px solid ${theme.border}`,
                background: "rgba(53, 80, 220, 0.06)",
                color: theme.primaryDark,
                alignSelf: isMobile ? "flex-start" : "center",
              }}
            >
              Step {currentStep + 1} / {steps.length}
            </Tag>
          )}
        </div>

        {/* Progress Steps for Mobile */}
        {isMobile && authRole !== "airline" && (
          <Card
            bordered={false}
            style={{
              marginBottom: 16,
              borderRadius: 16,
              boxShadow:
                "0 1px 2px rgba(19, 34, 114, 0.06), 0 8px 24px rgba(19, 34, 114, 0.06)",
            }}
            bodyStyle={{ padding: "16px 18px" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 8,
              }}
            >
              {steps.map((step, index) => (
                <Button
                  key={index}
                  type={currentStep === index ? "primary" : "default"}
                  shape="circle"
                  size="small"
                  onClick={() => setCurrentStep(index)}
                  style={{
                    width: 36,
                    height: 36,
                    padding: 0,
                    fontSize: 13,
                    fontWeight: 600,
                    ...(currentStep === index
                      ? {
                        background: theme.primary,
                        borderColor: theme.primary,
                        boxShadow: "0 4px 12px rgba(53, 80, 220, 0.35)",
                      }
                      : {}),
                  }}
                >
                  {index + 1}
                </Button>
              ))}
            </div>
            <div style={{ marginTop: 12, textAlign: "center" }}>
              <Text strong style={{ color: "rgba(0,0,0,0.75)" }}>
                {steps[currentStep].title}
              </Text>
            </div>
          </Card>
        )}

        {/* Main Content */}
        <Card
          bordered={false}
          className="hotel-module-main-card"
          style={{
            borderRadius: 16,
            boxShadow:
              "0 1px 2px rgba(19, 34, 114, 0.04), 0 12px 40px rgba(19, 34, 114, 0.08)",
            overflow: "hidden",
            position: "relative",
          }}
          bodyStyle={{
            padding: isMobile ? 16 : 32,
            paddingTop: isMobile ? 22 : 40,
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: 4,
              background: `linear-gradient(90deg, ${theme.primary} 0%, ${theme.primaryDark} 100%)`,
            }}
          />
          {!isMobile && (
            <Tabs
              className="hotel-module-tabs"
              activeKey={String(currentStep + 1)}
              onChange={(key) => setCurrentStep(Number(key) - 1)}
              style={{ marginBottom: 32 }}
            >
              {steps
                .filter((step, index) => authRole !== "airline" || index === 2)
                .map((step) => (
                  <TabPane
                    tab={
                      <span>
                        {step.icon}
                        <span style={{ marginLeft: '8px' }}>{step.title}</span>
                      </span>
                    }
                    key={String(step.key + 1)}
                  />
                ))}
            </Tabs>
          )}

          {/* Step 0 - Basic Info */}
          {currentStep === 0 && (
            <Row gutter={[32, 32]}>
              <Col xs={24} md={16}>
                <Form form={basicForm} layout="vertical">
                  <Form.Item
                    label="Hotel Name"
                    name="name"
                    rules={[{ required: true, whitespace: true, message: "Please enter hotel name" }]}
                  >
                    <Input size="large" placeholder="Enter hotel name" />
                  </Form.Item>

                  <Row gutter={[24, 24]}>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        label="Hotel Type"
                        name="hotelType"
                        rules={[{ required: true, message: "Please select hotel type" }]}
                      >
                        <Select size="large">
                          {HOTEL_TYPES.map((t) => (
                            <Option key={t} value={t}>{t}</Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} style={{ display: "none" }}>
                      <Form.Item label="Star Rating" name="starRating">
                        <Rate allowHalf />
                      </Form.Item>
                    </Col>
                  </Row>

                  {authRole !== "airline" ? (
                    <Form.Item
                      label="Airport Selection"
                      name="airline_ids"
                      rules={[{ required: true, message: "Airport Selection is required" }]}
                    >
                      <Select size="large" className="multiple-select" mode="multiple" options={airlineOptions} placeholder="Select Airport Airline(s)" />
                    </Form.Item>
                  ) : (
                    <Form.Item name="airline_ids" hidden>
                      <Select mode="multiple" options={airlineOptions} />
                    </Form.Item>
                  )}

                  <Form.Item label="Description" name="description">
                    <Input.TextArea rows={6} placeholder="Enter hotel description" />
                  </Form.Item>
                  <Row gutter={[24, 24]}>
                    <Col xs={24} sm={12}>
                      {/* <Form.Item
                        label="Commission Rate (%)"
                        name="commissionRate"
                        rules={[
                          { required: true, message: "Please enter commission rate" },
                          {
                            validator: (_, value) =>
                              value === undefined || value === null || value >= 0
                                ? Promise.resolve()
                                : Promise.reject(new Error("Commission rate cannot be negative")),
                          },
                        ]}
                      >
                        <InputNumber size="large" min={0} placeholder="Enter commission rate" style={{ width: "100%" }} />
                      </Form.Item> */}
                      <Form.Item
                        label="Hotel Email"
                        name="hotelEmail"
                        rules={[
                          { required: true, message: "Please enter hotel email" },
                          { type: "email", message: "Please enter a valid email" },
                        ]}
                      >
                        <Input size="large" placeholder="Enter hotel email" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        label="Contact No"
                        name="fullContact"
                        rules={[
                          { required: true, whitespace: true, message: "Please enter contact number" },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (!value) {
                                return Promise.resolve();
                              }
                              const countryCode = getFieldValue("countryCode") || "";
                              const dialCode = countryCode.replace("+", "");
                              const numberOnly = value.startsWith(dialCode) ? value.slice(dialCode.length) : value;

                              if (/^[0-9]{6,15}$/.test(numberOnly)) {
                                return Promise.resolve();
                              }
                              return Promise.reject(new Error("Contact number must be 6 to 15 digits"));
                            },
                          }),
                        ]}
                      >
                        <PhoneInput
                          country={"in"}
                          enableSearch
                          placeholder="Enter contact number"
                          enableLongNumbers={true}
                          disableMaxLength={true}
                          inputProps={{
                            maxLength: 20,
                          }}
                          onChange={(value, country) => {
                            const dialCode = country?.dialCode || "";
                            const numberOnly = value.startsWith(dialCode) ? value.slice(dialCode.length) : value;
                            basicForm.setFieldsValue({
                              countryCode: `+${dialCode}`,
                              contactNo: numberOnly,
                            });
                          }}
                          inputStyle={{
                            width: "100%",
                            height: "40px",
                            borderRadius: "10px",
                            border: "1px solid #d9d9d9",
                          }}
                          containerStyle={{
                            width: "100%",
                          }}
                          buttonStyle={{
                            borderRadius: "10px 0 0 10px",
                            border: "1px solid #d9d9d9",
                            background: "#fff",
                          }}
                        />
                      </Form.Item>
                      <Form.Item name="countryCode" hidden>
                        <Input />
                      </Form.Item>
                      <Form.Item name="contactNo" hidden>
                        <Input />
                      </Form.Item>

                    </Col>
                  </Row>
                  {!isEditMode && (
                    <Form.Item
                      label="Password"
                      name="password"
                      rules={[
                        { required: true, message: "Please enter password" },
                        { min: 6, message: "Password must be at least 6 characters" },
                      ]}
                    >
                      <Input.Password size="large" placeholder="Set login password" />
                    </Form.Item>
                  )}
                </Form>
              </Col>

              <Col xs={24} md={8}>
                <Card
                  title="Preview"
                  style={{
                    background: '#f5f5f5',
                    borderRadius: '12px',
                    position: 'sticky',
                    top: '20px'
                  }}
                >
                  <Title level={4}>
                    {basicForm.getFieldValue("name") || "Hotel Name"}
                  </Title>
                  <Text type="secondary">
                    {basicForm.getFieldValue("hotelType") || "Hotel Type"}
                  </Text>
                  <div style={{ marginTop: 8, display: "none" }}>
                    <Rate disabled value={basicForm.getFieldValue("starRating") || 0} />
                  </div>
                  <Divider />
                  <Paragraph ellipsis={{ rows: 4 }}>
                    {basicForm.getFieldValue("description") || "Description will appear here."}
                  </Paragraph>
                </Card>
              </Col>
            </Row>
          )}

          {/* Step 1 - Location */}
          {currentStep === 1 && (
            <Row gutter={[32, 32]}>
              <Col xs={24} lg={10}>
                <Card title="Location Details" style={{ borderRadius: '12px' }}>
                  <Form form={locationForm} layout="vertical">
                    <Row gutter={[24, 24]}>
                      <Col xs={24} sm={12}>
                        <Form.Item
                          label="Country"
                          name="country"
                          rules={[
                            { required: true, message: "Please enter country" },
                            { pattern: /^[a-zA-Z\s]+$/, message: "Country must contain only alphabets" },
                          ]}
                        >
                          <Input
                            placeholder="Country"
                            onKeyPress={(e) => {
                              if (!/[a-zA-Z\s]/.test(e.key)) e.preventDefault();
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12}>
                        <Form.Item label="State" name="state">
                          <Input placeholder="State" />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={[24, 24]}>
                      <Col xs={24} sm={12}>
                        <Form.Item
                          label="City"
                          name="city"
                          rules={[
                            { required: true, whitespace: true, message: "Please enter city" },
                            { pattern: /^[a-zA-Z\s]+$/, message: "City must contain only alphabets" },
                          ]}
                        >
                          <Input
                            placeholder="City"
                            onKeyPress={(e) => {
                              if (!/[a-zA-Z\s]/.test(e.key)) e.preventDefault();
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12}>
                        <Form.Item label="Landmark" name="landmark">
                          <Input placeholder="Near ..." />
                        </Form.Item>
                      </Col>
                    </Row>

                    {isMapsLoaded && (
                      <Form.Item
                        label="Address"
                        name="address"
                        rules={[{ required: true, message: "Address is required" }]}
                      >
                        <Autocomplete
                          onLoad={(autoC) => setAddressAutocomplete(autoC)}
                          onPlaceChanged={() => {
                            if (!addressAutocomplete) return;
                            const place = addressAutocomplete.getPlace();
                            if (!place.geometry) return;
                            const lat = place.geometry.location.lat();
                            const lng = place.geometry.location.lng();
                            setAddressValue(place.formatted_address || "");
                            locationForm.setFieldsValue({
                              address: place.formatted_address || "",
                              latitude: lat,
                              longitude: lng,
                            });
                          }}
                        >
                          <Input
                            value={addressValue}
                            placeholder="Search or enter address"
                            onChange={(e) => {
                              setAddressValue(e.target.value);
                              locationForm.setFieldsValue({ address: e.target.value });
                            }}
                          />
                        </Autocomplete>
                      </Form.Item>
                    )}
                  </Form>
                </Card>
              </Col>

              <Col xs={24} lg={14}>
                {isMapsLoaded && (
                  <Card
                    title="Map Location"
                    style={{ borderRadius: '12px', height: '100%' }}
                    bodyStyle={{ padding: 0 }}
                  >
                    <div style={{ height: isMobile ? '300px' : '400px' }}>
                      <LocationPicker
                        form={locationForm}
                        partner={hotel}
                        onLocationChange={({ address, country, state, city, latitude, longitude }) => {
                          setAddressValue(address);
                          locationForm.setFieldsValue({ address, country, state, city, latitude, longitude });
                        }}
                      />
                    </div>
                  </Card>
                )}
              </Col>
            </Row>
          )}

          {/* Step 2 - Rooms */}
          {currentStep === 2 && (
            <Space direction="vertical" style={{ width: "100%" }} size="large">
              {authRole !== "airline" && getAssociatedAirlineOptions().length > 0 && (
                <div style={{
                  background: '#f8fafc',
                  padding: '12px 16px',
                  borderRadius: '10px',
                  border: '1px solid #e2e8f0',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  marginBottom: 8
                }}>
                  <Text strong style={{ color: '#475569' }}>Selected Airline Context:</Text>
                  <Select
                    style={{ width: 280 }}
                    value={selectedAirlineId}
                    onChange={(val) => setSelectedAirlineId(val)}
                    options={getAssociatedAirlineOptions()}
                    placeholder="Select airline to manage allocation"
                  />
                </div>
              )}
              <Card
                title="Room Inventory Management"
                style={{ borderRadius: '12px' }}
                extra={
                  <Space size="middle">
                    {roomInventory.length > 0 && (
                      <>
                        <Button
                          icon={<QrcodeOutlined />}
                          onClick={() => handleViewQR()}
                        >
                          View Hotel QR
                        </Button>
                        {authRole === "airline" && (
                          <Tooltip
                            title="Click here to set the hotel allocation password"
                            open={highlightPasswordBtn}
                            placement="top"
                            color="#faad14"
                          >
                            <Button
                              icon={<LockOutlined />}
                              className={highlightPasswordBtn ? "pulse-highlight-btn" : ""}
                              style={{ color: '#faad14' }}
                              onClick={() => {
                                const matchingRooms = roomInventory.filter(r =>
                                  !selectedAirlineId || String(r.airline_id) === String(selectedAirlineId)
                                );
                                setSelectedAllocation({
                                  type: "All Allocated Types",
                                  qr_token: hotel.qr_token || matchingRooms[0]?.qr_token || roomInventory[0]?.qr_token,
                                  qr_password: hotel.qr_password || matchingRooms[0]?.qr_password || roomInventory[0]?.qr_password,
                                });
                                setPasswordModalVisible(true);
                                setHighlightPasswordBtn(false);
                              }}
                            >
                              Set Password
                            </Button>
                          </Tooltip>
                        )}
                      </>
                    )}
                    {authRole !== "airline" && (
                      <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={addRoomToInventory}
                        style={{ background: theme.primary, borderColor: theme.primary }}
                      >
                        Add Room Type
                      </Button>
                    )}
                  </Space>
                }
              >
                {roomInventory.length === 0 ? (
                  <Empty
                    description={authRole === "airline" ? "No room types allocated yet." : "No room types added yet. Click 'Add Room Type' to start."}
                    style={{ padding: '40px 0' }}
                  />
                ) : (
                  <Row gutter={[24, 24]}>
                    {roomInventory.map((room, index) => (
                      <Col xs={24} sm={12} md={8} key={index}>
                        <Card
                          size="small"
                          title={room.type}
                          extra={
                            <Space>
                              {authRole !== "airline" && (
                                <>
                                  <Button
                                    type="link"
                                    icon={<EditOutlined />}
                                    size="small"
                                    onClick={() => editRoomItem(room)}
                                  />
                                  <Button
                                    danger
                                    type="link"
                                    icon={<DeleteOutlined />}
                                    size="small"
                                    onClick={() => deleteRoomItem(room.type)}
                                  />
                                </>
                              )}
                            </Space>
                          }
                          style={{
                            border: `1px solid ${room.status === 0 ? '#ffccc7' : theme.border}`,
                            background: room.status === 0 ? '#fff1f0' : '#fff'
                          }}
                        >
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Text strong>Total Rooms:</Text>
                            <Text>{room.Total_rooms}</Text>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
                            <Text strong>Status:</Text>
                            <Tag color={room.status === 0 ? "red" : "green"}>
                              {room.status === 0 ? "Inactive" : "Active"}
                            </Tag>
                          </div>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                )}
              </Card>
            </Space>
          )}

          {/* Step 3 - Facilities */}
          {/* {currentStep === 3 && (
            <div>
              <Checkbox.Group
                value={hotel.facilities}
                onChange={handleFacilitiesChange}
                style={{ width: '100%' }}
              >
                <Row gutter={[24, 24]}>
                  {AMENITY_OPTIONS.map((facility) => (
                    <Col xs={12} sm={8} md={6} key={facility}>
                      <Checkbox value={facility}>{facility}</Checkbox>
                    </Col>
                  ))}
                </Row>
              </Checkbox.Group>
            </div>
          )} */}

          {/* Step 4 - Media */}
          {currentStep === 3 && (
            <Card title="Hotel Images" style={{ borderRadius: '12px' }}>
              <Upload
                listType="picture-card"
                multiple
                fileList={hotelImages}
                disabled={imageUploading}
                customRequest={async ({ file, onSuccess, onError }) => {
                  try {
                    setImageUploading(true);
                    const fileObj = file instanceof File ? file : file.originFileObj || file;
                    const url = await uploadToS3(fileObj);
                    setHotelImages((prev) => [
                      ...prev,
                      {
                        uid: file.uid,
                        name: file.name,
                        status: "done",
                        url,
                        thumbUrl: url,
                      },
                    ]);
                    if (onSuccess) onSuccess({ url });
                  } catch (e) {
                    ShowToast(e?.message || "Failed to upload hotel image", Severty.ERROR);
                    if (onError) onError(e);
                  } finally {
                    setImageUploading(false);
                  }
                }}
                beforeUpload={(file) => {
                  const isImage = file.type.startsWith("image/");
                  if (!isImage) {
                    ShowToast("Only image files are allowed", Severty.ERROR);
                    return Upload.LIST_IGNORE;
                  }
                  const isLt2M = file.size / 1024 / 1024 < 2;
                  if (!isLt2M) {
                    ShowToast("Image must be smaller than 2 MB", Severty.ERROR);
                    return Upload.LIST_IGNORE;
                  }
                  return true;
                }}
                onRemove={(file) => {
                  setHotelImages((prev) =>
                    prev.filter((f) => f.uid !== file.uid)
                  );
                }}
              >
                {!imageUploading ? (
                  <div>
                    <PlusOutlined />
                    <div style={{ marginTop: 8 }}>Upload</div>
                  </div>
                ) : (
                  <div>
                    <Spin size="small" />
                    <div style={{ marginTop: 8, fontSize: 12 }}>Uploading…</div>
                  </div>
                )}
              </Upload>
              <div style={{ marginTop: 16 }}>
                <Text type="secondary">Upload hotel images (JPG, PNG, max 2MB each)</Text>
              </div>
            </Card>
          )}

          {/* Step 5 - Policies */}
          {currentStep === 4 && (
            <Form form={policiesForm} layout="vertical">
              <Row gutter={[24, 24]}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Check-in Time"
                    name="checkInTime"
                    rules={[{ required: true, message: "Please select check-in time" }]}
                  >
                    <TimePicker format="HH:mm" style={{ width: "100%" }} size="large" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    label="Check-out Time"
                    name="checkOutTime"
                    rules={[{ required: true, message: "Please select check-out time" }]}
                  >
                    <TimePicker format="HH:mm" style={{ width: "100%" }} size="large" />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item label="Cancellation Policy" name="cancellationPolicy">
                <Input.TextArea rows={3} placeholder="Describe cancellation policy" />
              </Form.Item>

              <Row gutter={[24, 24]}>
                <Col xs={24} sm={12}>
                  <Form.Item label="Pet Allowed" name="petAllowed" valuePropName="checked">
                    <Checkbox>Pets allowed</Checkbox>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item label="Child Policy" name="childPolicy">
                    <Input.TextArea rows={2} placeholder="Describe child policy" />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          )}

          {/* Navigation Buttons */}
          {authRole !== "airline" && (
            <>
              <Divider style={{ marginTop: 32, marginBottom: 24, borderColor: theme.border }} />
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: 12,
                }}
              >
                <Button
                  onClick={handleBack}
                  disabled={currentStep === 0}
                  size="large"
                  style={{
                    minWidth: isMobile ? "100%" : 120,
                    borderRadius: 10,
                    fontWeight: 600,
                    borderColor: theme.border,
                  }}
                >
                  Back
                </Button>
                <Button
                  type="primary"
                  onClick={handleNext}
                  loading={isSubmitting}
                  size="large"
                  style={{
                    minWidth: isMobile ? "100%" : 140,
                    borderRadius: 10,
                    fontWeight: 600,
                    background: theme.primary,
                    borderColor: theme.primary,
                    boxShadow: "0 8px 24px rgba(53, 80, 220, 0.28)",
                  }}
                >
                  {currentStep === steps.length - 1 ? "Save & finish" : "Next"}
                </Button>
              </div>
            </>
          )}
        </Card>

        {/* Room Add / Edit Modal */}
        <Modal
          title={isAddingRoom ? "Add New Room Type" : `Edit Room Type — ${editingRoom?.type}`}
          open={roomEditModalVisible}
          onCancel={() => {
            setRoomEditModalVisible(false);
            setEditingRoom(null);
            setIsAddingRoom(false);
            roomForm.resetFields();
          }}
          footer={null}
          width={isMobile ? '90%' : 500}
        >
          <Form
            form={roomForm}
            layout="vertical"
            onFinish={handleRoomSubmit}
          >
            <Form.Item
              label="Room Type"
              name="type"
              rules={[{ required: true, message: "Please select room type" }]}
            >
              <Select size="large" disabled={!isAddingRoom}>
                {ROOM_TYPES.map((type) => (
                  <Option key={type} value={type}>{type}</Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Total Rooms"
              name="Total_rooms"
              rules={[{ required: true, message: "Please enter total count" }]}
            >
              <InputNumber min={1} style={{ width: "100%" }} size="large" placeholder="Total rooms" />
            </Form.Item>

            {!isAddingRoom && (
              <Form.Item
                label="Status"
                name="status"
                rules={[{ required: true, message: "Please select status" }]}
                initialValue={1}
              >
                <Select size="large">
                  <Option value={1}>Active</Option>
                  <Option value={0}>Inactive</Option>
                </Select>
              </Form.Item>
            )}

            <div style={{ textAlign: "right", marginTop: 24 }}>
              <Space>
                <Button onClick={() => setRoomEditModalVisible(false)}>
                  Cancel
                </Button>
                <Button type="primary" htmlType="submit">
                  {isAddingRoom ? "Add Type" : "Update Type"}
                </Button>
              </Space>
            </div>
          </Form>
        </Modal>
      </div>

      <style>{`
        .hotel-module-page .hotel-module-tabs .ant-tabs-nav {
          margin-bottom: 8px;
        }
        .hotel-module-page .hotel-module-tabs .ant-tabs-nav::before {
          border-color: ${theme.border};
        }
        .hotel-module-page .hotel-module-tabs .ant-tabs-tab {
          padding: 12px 16px;
          font-weight: 600;
        }
        .hotel-module-page .hotel-module-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
          color: ${theme.primary} !important;
        }
        .hotel-module-page .hotel-module-tabs .ant-tabs-ink-bar {
          background: ${theme.primary};
          height: 3px !important;
          border-radius: 3px 3px 0 0;
        }
        .hotel-module-page .ant-btn-primary:hover {
          background: var(--theme1Dark, #132272) !important;
          border-color: var(--theme1Dark, #132272) !important;
        }
        @keyframes pulse-border {
          0% {
            box-shadow: 0 0 0 0 rgba(250, 173, 20, 0.7);
          }
          70% {
            box-shadow: 0 0 0 10px rgba(250, 173, 20, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(250, 173, 20, 0);
          }
        }
        .pulse-highlight-btn {
          animation: pulse-border 1.5s infinite;
          border: 2px solid #faad14 !important;
          background-color: #fffbe6 !important;
          font-weight: bold !important;
        }
      `}</style>

      {/* QR Code Modal */}
      <Modal
        title={
          <Space>
            <QrcodeOutlined />
            <span>Hotel Allocation QR</span>
          </Space>
        }
        visible={qrModalVisible}
        onCancel={() => setQrModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setQrModalVisible(false)}>Close</Button>,
          authRole !== "airline" && (
            <Button
              key="resend"
              type="primary"
              icon={<MailOutlined />}
              onClick={() => handleResendEmail()}
            >
              Resend Email
            </Button>
          )
        ].filter(Boolean)}
        centered
        width={400}
      >
        {selectedAllocation && (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{
              background: 'white',
              padding: 16,
              borderRadius: 12,
              display: 'inline-block',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              marginBottom: 20
            }}>
              <img
                src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(`${WebsiteURL}/qr-register/${selectedAllocation.qr_token}`)}`}
                alt="QR Code"
                style={{ width: 200, height: 200 }}
              />
            </div>
            <Title level={5} style={{ marginBottom: 4 }}>Passenger Registration Link</Title>
            <Text copyable style={{ fontSize: 13, color: '#666' }}>
              {`${WebsiteURL}/qr-register/${selectedAllocation.qr_token}`}
            </Text>
            <Divider style={{ margin: '16px 0' }} />
            <div style={{ textAlign: 'left' }}>
              <Row gutter={[16, 8]}>
                <Col span={12}><Text type="secondary">Status:</Text></Col>
                <Col span={12}><Badge status={selectedAllocation.status === 1 ? "success" : "default"} text={selectedAllocation.status === 1 ? "Active Allocation" : "Inactive Allocation"} /></Col>
                {/* <Col span={12}><Text type="secondary">Total Allocated Rooms:</Text></Col>
                <Col span={12}><Text strong>{selectedAllocation.available_rooms}</Text></Col> */}
                <Col span={12}><Text type="secondary">Password Protected:</Text></Col>
                <Col span={12}>
                  <Tag color={selectedAllocation.qr_password ? "green" : "default"}>
                    {selectedAllocation.qr_password ? "Yes" : "No"}
                  </Tag>
                </Col>
              </Row>
            </div>
          </div>
        )}
      </Modal>

      {/* Set Password Modal */}
      <Modal
        title={
          <Space>
            <LockOutlined />
            <span>Set Hotel Allocation Password</span>
          </Space>
        }
        visible={passwordModalVisible}
        onCancel={() => setPasswordModalVisible(false)}
        onOk={() => passwordForm.submit()}
        confirmLoading={passwordLoading}
        okText="Save Password"
        destroyOnClose
      >
        <div style={{ marginBottom: 16 }}>
          <Text type="secondary">
            Passengers will be required to enter this password after scanning the QR code for this hotel.
          </Text>
        </div>
        <Form
          form={passwordForm}
          onFinish={handleSetPassword}
          layout="vertical"
        >
          <Form.Item
            label="New Password"
            name="password"
            rules={[
              { required: true, whitespace: true, message: "Please enter a password" },
              { min: 4, message: "Password must be at least 4 characters" }
            ]}
          >
            <Input.Password placeholder="Enter secure password" size="large" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default HotelModule;